export default __webpack_public_path__ + "static/media/layer_pop_01.a2686bf5.png";